<template>
  <div v-if="coursesMode" class="wrapper courses-mode-wrapper">
    <h1 class="mode-name">
      {{ modeName }}
    </h1>
    <div class="mode-tabs">
      <div class="tab-item" :class="{ 'active': coursesMode === 'list' }" @click="handleChange('list')">
        <div class="iconfont icon-list" />
      </div>
      <div class="tab-item" :class="{ 'active': coursesMode === 'card' }" @click="handleChange('card')">
        <div class="iconfont icon-card" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coursesMode: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      langContext: this.$t('featureComponents.CoursesModeChange'),
    }
  },
  computed: {
    modeName() {
      return this.langContext.modeNames[this.coursesMode]
    },
  },
  methods: {
    /**
     * 切换模式
     */
    handleChange(mode) {
      if (this.loading) return
      this.$emit('mode-change', mode)
      this.Sensors.track('courses_list_mode_switching_click', {
        mode,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.courses-mode-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 40px;

  .mode-name {
    font-size: 14px;
    color: var(--txt-color-lv2);
  }

  .mode-tabs {
    display: flex;
    margin-left: 20px;
    height: 28px;
    border-radius: 14px;
    border: 1px solid var(--txt-color-link);

    .tab-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 56px;
      height: 26px;
      color: var(--txt-color-link);
      cursor: pointer;

      &.active {
        background: var(--txt-color-link);
        color: #fff;
        border-radius: 14px;
      }

      .iconfont {
        font-size: 16px;
      }
    }
  }
}
</style>
